/*
 * Premium Product FAQ
 * Scoped accordion: one item open at a time within each category group,
 * accessible aria-expanded toggling, and a fade-up reveal on scroll.
 * No external libraries.
 */
(function () {
  'use strict';

  class PremiumProductFaq extends HTMLElement {
    constructor() {
      super();
      this.onTriggerClick = this.onTriggerClick.bind(this);
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-ppf-trigger]'));
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.onTriggerClick);
      });

      this.setupReveal();
    }

    disconnectedCallback() {
      if (this.triggers) {
        this.triggers.forEach((trigger) => {
          trigger.removeEventListener('click', this.onTriggerClick);
        });
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    onTriggerClick(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('[data-ppf-item]');
      const group = trigger.closest('[data-ppf-group]');
      if (!item) return;

      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        this.closeItem(item);
        return;
      }

      // Only one item open per group.
      if (group) {
        group
          .querySelectorAll('[data-ppf-item].is-open')
          .forEach((other) => this.closeItem(other));
      }

      this.openItem(item);
    }

    openItem(item) {
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-ppf-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    closeItem(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-ppf-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    setupReveal() {
      const prefersReduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReduced || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.classList.add('is-observing');

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this.observer.disconnect();
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
      );

      this.observer.observe(this);
    }
  }

  if (!customElements.get('premium-product-faq')) {
    customElements.define('premium-product-faq', PremiumProductFaq);
  }
})();
